export enum PortfolioWorkspaceSegment {
  Home = 'home',
  Roadmap = 'roadmap',
  Artifacts = 'artifacts',
  Settings = 'settings',
  Profile = 'profile',
  Connectors = 'connectors',
}

export enum ProductWorkspaceSegment {
  Home = 'home',
  Ideas = 'ideas',
  Hypotheses = 'hypotheses',
  Experiments = 'experiments',
  Insights = 'insights',
  Artifacts = 'artifacts',
  Settings = 'settings',
  Profile = 'profile',
  Connectors = 'connectors',
}

export interface OrganizationParams {
  organizationId: string
}

export interface PortfolioParams extends OrganizationParams {
  portfolioId: string
}

export interface ProductWorkspaceParams extends PortfolioParams {
  productId: string
}

export interface OptionalProductWorkspaceParams extends PortfolioParams {
  productId?: string
}

export interface InsightDetailParams extends ProductWorkspaceParams {
  insightId: string
}

export interface OptionalInsightDetailParams extends ProductWorkspaceParams {
  insightId?: string
}

export interface ArtifactDetailParams extends ProductWorkspaceParams {
  artifactId: string
}

export interface HypothesisDetailParams extends ProductWorkspaceParams {
  hypothesisId: string
}

export interface IdeaDetailParams extends ProductWorkspaceParams {
  ideaId: string
}

export interface OptionalIdeaDetailParams extends ProductWorkspaceParams {
  ideaId?: string
}

export interface ExperimentDetailParams extends ProductWorkspaceParams {
  experimentId: string
}
